/** Start of comparison window for Users tab summary metrics (audit aggregation uses this window). */
export const USERS_SUMMARY_BASELINE_ISO = '2025-10-01T00:00:00.000Z';

export const USERS_SUMMARY_AS_OF_SUBTITLE = 'as of today';
